import { PlusOutlined } from "@ant-design/icons";
import { Button, Col, Flex, Form, Input, Row, Table, TableColumnsType } from "antd";
import { useGetIpScalesQuery } from "api/sales-order/ip-scale-api";
import { OBJ_COLOR } from "commons/constants";
import useFormToggle from "hooks/useFormToggle";
import { useMemo, useState } from "react";
import IpScaleModal from "./components/IpScaleModal";
import { IpScale } from "./types";

interface FilterForm {
	search?: string;
}

const IpScalePage = () => {
	const [form] = Form.useForm<FilterForm>();

	const [page, setPage] = useState({ pageNumber: 1, pageSize: 20 });
	const [search, setSearch] = useState("");

	const { open, onOpen, onClose } = useFormToggle();

	const { data, isFetching } = useGetIpScalesQuery();

	const filteredData = useMemo(() => {
		const keyword = search.trim().toLowerCase();
		if (!keyword) return data ?? [];
		return (data ?? []).filter((item) => item.farmName.toLowerCase().includes(keyword) || item.scaleIp.toLowerCase().includes(keyword));
	}, [data, search]);

	const handleOnFinish = (values: FilterForm) => {
		setPage((prev) => ({ ...prev, pageNumber: 1 }));
		setSearch(values.search ?? "");
	};

	const handleOnReset = () => {
		form.resetFields();
		setSearch("");
		setPage({ pageNumber: 1, pageSize: 20 });
	};

	const columns: TableColumnsType<IpScale> = [
		{
			title: "STT",
			dataIndex: "id",
			width: 60,
			render: (_, __, index) => (page.pageNumber - 1) * page.pageSize + index + 1,
		},
		{
			title: "Tên trại",
			dataIndex: "farmName",
			ellipsis: true,
		},
		{
			title: "IP cân",
			dataIndex: "scaleIp",
			width: 200,
		},
	];

	return (
		<>
			<Row gutter={[20, 20]}>
				<Col span={24}>
					<Form form={form} layout="vertical" onFinish={handleOnFinish}>
						<Row gutter={[10, 10]} align="bottom">
							<Col xs={12} xl={6}>
								<Form.Item label="Tìm kiếm" name="search">
									<Input placeholder="Tên trại, IP cân..." allowClear />
								</Form.Item>
							</Col>
							<Col xs={12} xl={4}>
								<Form.Item>
									<Button style={{ width: "100%" }} type="primary" htmlType="submit" loading={isFetching}>
										Tìm kiếm
									</Button>
								</Form.Item>
							</Col>
							<Col xs={12} xl={4}>
								<Form.Item>
									<Button style={{ width: "100%", background: OBJ_COLOR.WARNING }} type="primary" onClick={handleOnReset}>
										Reset
									</Button>
								</Form.Item>
							</Col>
							<Col xs={12} xl={10}>
								<Form.Item>
									<Flex justify="flex-end">
										<Button type="primary" icon={<PlusOutlined />} onClick={onOpen}>
											Thêm mới
										</Button>
									</Flex>
								</Form.Item>
							</Col>
						</Row>
					</Form>
				</Col>

				<Col span={24}>
					<Table
						rowKey="id"
						loading={isFetching}
						columns={columns}
						dataSource={filteredData}
						scroll={{ x: true }}
						pagination={{
							current: page.pageNumber,
							pageSize: page.pageSize,
							total: filteredData.length,
							showSizeChanger: true,
							pageSizeOptions: ["20", "50", "100"],
							onChange: (pageNumber, pageSize) => setPage({ pageNumber, pageSize }),
						}}
					/>
				</Col>
			</Row>

			<IpScaleModal open={open} onClose={onClose} />
		</>
	);
};

export default IpScalePage;
